<template>
  <div class="">
    <ViewMemberSidebar
      :isSidebarActive="isViewMemberSidebarActive"
      @closeSidebar="toggleViewMemberSidebar"
    />
    <Add-Member-Sidebar
      :isSidebarActive="openAddMemberSidebar"
      @closeSidebar="toggleAddMemberSidebar"
    />
    <modal
      :show.sync="addmbrModal"
      header-classes="pt-3 px-4"
      hide-footer
      footerClasses="hidden"
      bodyclasses=""
    >
      <h6 slot="header" class="text-xl font-semibold">Add Member</h6>
      <div class="mb-2">
        <b-form-input placeholder="Enter member name" size="sm"></b-form-input>
      </div>
      <div class="mt-2">
        <b-list-group flush class="cust-overflow-y5 h-64">
          <b-list-group-item
            action
            v-for="(member, index) in members"
            :key="'member-' + index"
            class="cursor-pointer"
          >
            <b-row align-v="center">
              <b-col md="auto" class="pl-0">
                <!-- TODO: Dynamic user image -->
                <b-avatar variant="primary" class="p-4 avatar"></b-avatar>
              </b-col>
              <b-col class="pl-0 pr-0">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <h4 class="mb-0 text-sm font-semibold">
                      {{ member.firstname }} {{ member.lastname }}
                    </h4>
                  </div>
                </div>
              </b-col>
              <b-col>
                <b-form-checkbox
                  v-model="member.isSelected"
                  name="checkbox-1"
                  :value="true"
                >
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </div>
    </modal>
    <modal
      :show.sync="viewmbrModal"
      header-classes="pt-4 pb-0 px-4"
      hide-footer
      footerClasses="hidden"
    >
      <h6 slot="header" class="text-xl font-semibold">View Member</h6>
      <div class="mb-2">
        <b-form-input placeholder="Enter member name" size="sm"></b-form-input>
      </div>
      <div class="mt-2">
        <b-list-group flush class="cust-overflow-y5 h-64">
          <b-list-group-item
            action
            v-for="member in members"
            :key="'members-' + member._id"
            class="cursor-pointer py-1"
          >
            <ChannelMember :member="member" :key="'member-' + member._id" />
          </b-list-group-item>
        </b-list-group>
      </div>
    </modal>
    <div class="mt-6 h-full">
      <div class="flex justify-between items-center mb-4 w-full">
        <h2 class="font-semibold">Members</h2>
        <div class="border1px rounded-full flex items-center p-2">
          <feather-icon
            @click="toggleViewMemberSidebar(true)"
            block
            class="cursor-pointer md:block lg:block hidden"
            icon="UsersIcon"
            svgClasses="w-4 h-4 text-primary"
            v-b-tooltip.hover
            title="View Members"
          ></feather-icon>
          <feather-icon
            @click.stop="viewmbrModal = true"
            block
            class="cursor-pointer md:hidden lg:hidden block"
            icon="UsersIcon"
            svgClasses="w-4 h-4 text-primary"
          ></feather-icon>
        </div>

        <!-- <div class="md:block lg:block hidden">
          <base-button
            type="primary"
            outline
            size="sm"
            @click="toggleAddMemberSidebar(true)"
            >Add Members</base-button
          >
          <base-button
            type="primary"
            size="sm"
            @click="toggleViewMemberSidebar(true)"
            >View Members</base-button
          >
        </div>
        <div class="md:hidden lg:hidden block">
          <base-button
            type="primary"
            outline
            size="sm"
            @click="addmbrModal = true"
            >Add Member</base-button
          >
          <base-button type="primary" size="sm" @click="viewmbrModal = true"
            >View Member</base-button
          >
        </div> -->
      </div>

      <JoinRequests v-if="requests.length && CanCurruntUserAddMember()" />

      <b-list-group flush class="cust-overflow-y5 h27vh overflow-x-hidden">
        <b-list-group-item
          action
          v-for="member in members"
          :key="'members-' + member._id"
          class="cursor-pointer py-1 pl-2 pr-4 disp-content"
        >
          <ChannelMember :member="member" :key="'member-' + member._id" />
        </b-list-group-item>
      </b-list-group>
      <!-- <div class="bottom-0 z-50">
        <base-button
          type="primary"
          class="
            active
            w-full
            rounded-none
            font-semibold
            bottom-0
            left-0
            w-full
          "
          aria-pressed="true"
  
          >VIEW MEMBERS</base-button
        >
      </div> -->
    </div>
  </div>
</template>

<script>
import AddMemberSidebar from "./AddMemberSidebar.vue";
import ChannelMember from "./ChannelMember";
import JoinRequests from "./JoinRequests";
import ViewMemberSidebar from "./ViewMemberSidebar";
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    AddMemberSidebar,
    ViewMemberSidebar,
    ChannelMember,
    JoinRequests,
  },
  data() {
    return {
      openAddMemberSidebar: false,
      isViewMemberSidebarActive: false,
      addmbrModal: false,
      viewmbrModal: false,
      non_members: [],
    };
  },
  computed: {
    ...mapGetters("channel", {
      members: "visibleMembers",
    }),
    ...mapState("channel", {
      requests: "selectedChannelJoinRequest",
    }),
    ...mapState("auth", {
      userData: "user",
    }),
  },
  methods: {
    AddMember() {
      this.toggleAddMemberSidebar(true);
    },
    toggleAddMemberSidebar(val = false) {
      this.openAddMemberSidebar = val;
    },
    toggleViewMemberSidebar(val = false) {
      this.isViewMemberSidebarActive = val;
    },
    showSwal() {
      this.$swal({
        title: `Work in Progress`,
        text: "We are working to offer you the best experience",
        // buttonsStyling: false,
        showCancelButton: false,
        cancelButtonColor: "",
        confirmButtonClass: "btn btn-primary bg-primary",
        confirmButtonText: "OK",
        cancelButtonText: "No",
        icon: "info",
      });
    },
    CanCurruntUserAddMember() {
      let User = this.members.find(
        (el) =>
          (el.role == "owner" || el.role == "admin") &&
          el.createdBy._user == this.userData._id
      );
      return !!User;
    },
  },
  mounted() {
    // console.log("members", this.members);
  },
};
</script>
<style scoped>
.h27vh {
  height: 27vh;
}
</style>
